import React from 'react';
import { Stack, IconButton, Text, DataList, DataItem } from '@cad-arc';
import { LinkText } from '../../../../../common/components/link-text';
import { EventDetailsTabEventDto } from '@mark43/cad-api';
import { useOpenEventPanel } from '../../../../use-open-event-panel';
import { TabIndented } from '../../../../../panels/entity-panels/tabs/tab-indented';
import { TabNoData } from '../../../../../panels/entity-panels/tabs/tab-no-data';
import { formatMonthDayYear } from '../../../../../common/helpers/utils';

export function EventList(props: {
    events: EventDetailsTabEventDto[];
    onDelete?: (
        params: Pick<EventDetailsTabEventDto, 'eventId' | 'eventNumber'>
    ) => Promise<unknown>;
    title?: string;
    renderLabel: (event: EventDetailsTabEventDto) => string;
}): React.ReactElement {
    const { onDelete, events, title, renderLabel } = props;
    const openEventPanel = useOpenEventPanel();
    return (
        <Stack spacing={2}>
            {title && <Text color="tertiary">{title}</Text>}
            <TabIndented>
                {!events.length ? (
                    <TabNoData />
                ) : (
                    <DataList>
                        {events.map((event) => {
                            const label = renderLabel(event);
                            const createdDateInDisplayFormat = event?.createdDateUtc
                                ? formatMonthDayYear(event.createdDateUtc)
                                : null;

                            return (
                                <Stack
                                    key={event.eventId}
                                    direction="row"
                                    justifyContent="space-between"
                                >
                                    <Stack spacing={0} minWidth={0}>
                                        <DataItem dataKey={label}>
                                            <LinkText
                                                onClick={() => {
                                                    openEventPanel({ eventId: event.eventId });
                                                }}
                                            >
                                                {event.eventNumber}
                                            </LinkText>
                                        </DataItem>
                                        {event.comment ? (
                                            <TabIndented>
                                                <DataItem key={event.eventId} dataKey="Comments">
                                                    {event.comment}
                                                </DataItem>
                                                {event?.callForService && (
                                                    <DataItem
                                                        key={event.eventId}
                                                        dataKey="Call For Service"
                                                    >
                                                        {event.callForService}
                                                    </DataItem>
                                                )}
                                                {createdDateInDisplayFormat && (
                                                    <DataItem key={event.eventId} dataKey="Date">
                                                        {createdDateInDisplayFormat}
                                                    </DataItem>
                                                )}
                                            </TabIndented>
                                        ) : null}
                                    </Stack>
                                    {!!onDelete && (
                                        <IconButton
                                            style={{ marginTop: '-3px' }}
                                            variant="ghost"
                                            size="sm"
                                            onClick={() =>
                                                onDelete({
                                                    eventId: event.eventId,
                                                    eventNumber: event.eventNumber,
                                                })
                                            }
                                            aria-label="TrashCan"
                                            icon="TrashCan"
                                        />
                                    )}
                                </Stack>
                            );
                        })}
                    </DataList>
                )}
            </TabIndented>
        </Stack>
    );
}
